(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('protocolLink', [ProtocolLinkFn]);

    // protocol link component, shows protocol on hover in a popup window
    function ProtocolLinkFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: "/app/ringfoon/templates/ringfoon-protocol-link.template.html"
        };
        return directive;
    }
})();
